/*
 * @Author: Teemo Ding
 * @Date: 2021-03-03 09:27:05
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-05-28 10:48:26
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/NoProduct.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Button } from 'src/components/Antd';
import { useHistory } from 'react-router';
const NoProduct = (props) => {
  const { text, link } = props;
  const _h = useHistory();
  return (
    <div className={css.noProductContainer}>
      {text ||
        'No simple product has been found. Please create a simple product first.'}
      <Button
        type='primary'
        onClick={() => {
          _h.push(link || '/product/simpleProduct/new');
        }}
        className={css.addProduct}>
        Add Product
      </Button>
    </div>
  );
};
export default NoProduct;
